import { TranslateType } from '../../translation/translationContext.types';
import { EntityWarning, SearchWarning, SearchableEntityType } from '../globalSearch.types';
import { getEntityTabLabel } from '../lib/getEntityTabLabel';

interface UseGlobalSearchEntityWarningParams {
  activeEntityType: SearchableEntityType | null;
  warnings: SearchWarning[];
  isStore: boolean;
  translate: TranslateType;
  onRetry: (entityTypes: SearchableEntityType[]) => void;
}

const useGlobalSearchEntityWarning = ({
  activeEntityType,
  warnings,
  isStore,
  translate,
  onRetry,
}: UseGlobalSearchEntityWarningParams) => {
  const activeWarnings =
    activeEntityType === null
      ? warnings
      : warnings.filter((warning) => warning.entityType === activeEntityType);

  const warningEntityLabel = activeWarnings
    .map((warning) =>
      warning.entityType
        ? translate(getEntityTabLabel({ entityType: warning.entityType, isStore }))
        : null,
    )
    .filter((label): label is string => Boolean(label))
    .join(', ');

  const warningEntityTypes = Array.from(
    new Set(
      activeWarnings
        .map((warning) => warning.entityType)
        .filter((entityType): entityType is SearchableEntityType => Boolean(entityType)),
    ),
  );

  const entityWarning: Omit<EntityWarning, 'isRetrying'> | null = warningEntityLabel
    ? { entityLabel: warningEntityLabel, onRetry: () => onRetry(warningEntityTypes) }
    : null;

  return { entityWarning };
};

export default useGlobalSearchEntityWarning;
